import {
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
} from '@angular/core';
import { List } from 'immutable';
import {
  ITrackingAction,
  ITrackingObject,
} from '../../../tracking/tracking.data';

@Component({
  selector: 'app-labeled-section',
  templateUrl: './labeled-section.component.html',
  styleUrls: ['./labeled-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LabeledSectionComponent implements OnInit {
  @Input() header: string;
  @Input() metadata: string;
  @Input() metadataUrl: string;
  @Input() items: List<any>;
  @Input() metadataE2eId: string;
  @Input() trackByFn: Function;
  @Input() metadataTrackingObject: ITrackingObject;
  @Input() metadataTrackingAction: ITrackingAction;
  @Input() metadataTrackingAdditionalProperties: any;

  @Output() onMetadataClick: EventEmitter<void> = new EventEmitter<void>();

  @ContentChild(TemplateRef, { static: false }) template: TemplateRef<any>;

  constructor() {}

  ngOnInit() {}
}
